import SearchApi from '../../agent/search';
import AlgoliaIndex from '../algolia-index';
import AdminIndexFormatters from './admin-index-formatters';

const filterIfEditor = (results) => {
  const currentUser = getCurrentUser();
  const userIsEditorNotAdmin = currentUser.is_editor && !currentUser.admin;

  if (userIsEditorNotAdmin) return SearchApi.editorFilterSearchableObjectIds(results);
  return results;
};

const AdminIndices = {
  FOLDER: new AlgoliaIndex(
    APP_CONSTANTS.ALGOLIA_INDEXES.FOLDER,
    {
      attributesToSnippet: ['name', 'description'],
    },
    AdminIndexFormatters.formatAdminResult,
    (results) => filterIfEditor(results),
  ),

  TRAINING: new AlgoliaIndex(
    APP_CONSTANTS.ALGOLIA_INDEXES.TRAINING,
    {
      attributesToSnippet: ['name', 'title', 'description', 'content', 'object_tags'],
    },
    AdminIndexFormatters.formatAdminResult,
    (results) => filterIfEditor(results),
  ),

  ACADEMIES: new AlgoliaIndex(
    APP_CONSTANTS.ALGOLIA_INDEXES.ACADEMIES,
    {
      attributesToSnippet: ['name', 'description'],
    },
    AdminIndexFormatters.formatAdminResult,
    (results) => filterIfEditor(results),
  ),

  getAll() {
    return [this.FOLDER, this.TRAINING];
  },

  getAllForAcademy() {
    return [this.FOLDER, this.TRAINING, this.ACADEMIES];
  },
};

export default AdminIndices;
